import { createFileRoute } from '@tanstack/react-router';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/')({
  staticData: {
    path: PAGE_PATHS.VIOLATION_TICKETS,
    key: EntityTypeConfigKeys.ViolationTicket,
  },
});
